module.exports = __webpack_public_path__ + "static/media/goodnest_app4_preview.204ef7fb.jpg";